import { useMutation, useQuery } from "@apollo/client"
import { GET_PATIENT_WELLNESS_PLAN } from "../../../graphql/queries"
import { IGetPatientWellnessPlanOutput, IGetPatientWellnessPlanInput } from "../../../graphql/types/queries/healthCoaching"
import { Button, Flex, Heading, Text } from "rebass/styled-components"
import PleaseWait from "../../../components/PleaseWait"
import WellnessPlanTextEditor from "./WellnessPlanTextEditor"
import { Form, Formik } from "formik"
import styled from "styled-components"
import { parseStringify } from "../../../utils/StringUtils"
import { IDeleteWellnessPlanInput, IDeleteWellnessPlanOutput, IUpsertWellnessPlanInput, IUpsertWellnessPlanOutput } from "../../../graphql/types/mutations/healthcoaching"
import { DELETE_WELLNESS_PLAN, UPSERT_WELLNESS_PLAN } from "../../../graphql/mutations"
import { toast } from "react-toastify"

const EditorWrapper = styled(Flex)`
overflow-y:auto;
width: 100%;
 max-width: 836px;
padding-right: 24px;
/* max-height: calc(100vh - 44px); */
&::-webkit-scrollbar-track {
  background: transparent;
}
&::-webkit-scrollbar-thumb {
  background: #6c89b7;
  border-radius: 5px;
}
    &::-webkit-scrollbar {
        width: 7px;
        border: 1px solid transparent;
    }
`
interface IWellnessPlanProps {
  patientId: string
  onClose: () => void
}

export const WellnessPlan: React.FC<IWellnessPlanProps> = ({ patientId, onClose }) => {
  const { data, loading } = useQuery<IGetPatientWellnessPlanOutput, IGetPatientWellnessPlanInput>(GET_PATIENT_WELLNESS_PLAN, {
    fetchPolicy: 'network-only',
    variables: {
      userId: patientId
    }
  })
  const [save, { loading: loadingSave }] = useMutation<IUpsertWellnessPlanOutput, IUpsertWellnessPlanInput>(UPSERT_WELLNESS_PLAN, {
    refetchQueries: [
      {
        query: GET_PATIENT_WELLNESS_PLAN, variables: {
          userId: patientId
        }
      }],
    awaitRefetchQueries: true,
    onCompleted: (e) => {
      if (e.healthCoachUpsertWellnessPlan && e.healthCoachUpsertWellnessPlan.ok) {
        toast.success('Wellness Plan Saved', {
          autoClose: 3000
        });
        onClose()
      } else {
        toast.error('Wellness Plan Not Saved', {
          autoClose: 3000
        });
      }
    },
    onError: (e) => {
      console.log(e)
      toast.error('An error occured', {
        autoClose: 3000
      });
    }
  })
  const [deletePlan, { loading: loadingDelete }] = useMutation<IDeleteWellnessPlanOutput, IDeleteWellnessPlanInput>(DELETE_WELLNESS_PLAN, {
    refetchQueries: [
      {
        query: GET_PATIENT_WELLNESS_PLAN, variables: {
          userId: patientId
        }
      }],
    awaitRefetchQueries: true,
    onCompleted: (e) => {
      if (e.healthCoachDeleteWellnessPlan && e.healthCoachDeleteWellnessPlan.ok) {
        toast.success('Wellness Plan Deleted', {
          autoClose: 3000
        });
        onClose()
      } else {
        toast.error('Wellness Plan Not Deleted', {
          autoClose: 3000
        });
      }
    },
    onError: (e) => {
      console.log(e)
      toast.error('An error occured', {
        autoClose: 3000
      });
    }
  })

  return (
    <Flex flexDirection={'column'} style={{ width: 'min(600px, 80vw)', maxHeight: '90vh' }}>
      <Flex
        mb={3}
        alignSelf='center' style={{ padding: '8px', borderRadius: 8, backgroundColor: 'rgb(33, 150, 243)', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="36" height="36" viewBox="0 0 48 48">
                <ellipse cx="20.51" cy="23.56" fill="none" strokeWidth={'2'} stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="4.22" ry="10.21" transform="rotate(-20 20.523 23.56)" />
              <ellipse cx="14.75" cy="28.84"  strokeWidth={'2'} fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="4.22" ry="10.21" transform="rotate(-65 14.751 28.839)" />
              <ellipse cx="27.49" cy="23.56"  strokeWidth={'2'} fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="10.21" ry="4.22" transform="rotate(-70 27.495 23.562)" />
              <ellipse cx="33.25" cy="28.84"  strokeWidth={'2'} fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" rx="10.21" ry="4.22" transform="rotate(-25 33.242 28.831)" />
              </svg>
      </Flex>
      <Heading textAlign={
        'center'
      } mb={4}>WELLNESS PLAN</Heading>

      <Flex flex={1}>
        {!!loading ? (
          <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
            <PleaseWait />
          </Flex>
        ) : (

          <EditorWrapper flexDirection={'column'} id='editorWrap'>
            <Formik
              initialValues={{
                ...data?.healthCoachGetPatientWellnessPlan || {
                  plan: '',
                  internalNotes: ''
                }
              }}
              onSubmit={(values, actions) => {
                console.log({ values });
                save({
                  variables: {
                    userId: patientId,
                    plan: values.plan || '',
                    revisionFromId: data && data.healthCoachGetPatientWellnessPlan ? data.healthCoachGetPatientWellnessPlan.id : undefined,
                    internalNotes: values.internalNotes || ''
                  }
                })
              }}
            >
              {({ touched, errors, isValid, values, submitForm, setFieldValue, setFieldTouched }) => {
                // console.log({ errors, touched, values });
                return (<Form>

                  <WellnessPlanTextEditor
                    name={'plan'}
                    values={values}
                    setFieldValue={setFieldValue}
                    touched={touched} errors={errors}
                    initialValue={data?.healthCoachGetPatientWellnessPlan?.plan || ''}
                  />
                  <Text mt={4} mb={2} style={{ fontWeight: 500 }}>Internal notes <span style={{ fontWeight: 300, textDecoration: 'underline' }}>(Not visible to customer)</span>:</Text>
                  <WellnessPlanTextEditor
                    name={'internalNotes'}
                    values={values}
                    setFieldValue={setFieldValue}
                    touched={touched} errors={errors}
                    initialValue={data?.healthCoachGetPatientWellnessPlan?.internalNotes || ''}
                  />
                  <Flex justifyContent={'space-between'} mt={4}>
                    {!!data && data.healthCoachGetPatientWellnessPlan && data.healthCoachGetPatientWellnessPlan.id && (
                      <Button type='button' variant={'danger'} style={{ width: 'fit-content', padding: '4px 16px' }} disabled={!!loading || !!loadingSave || !!loadingDelete} onClick={e => deletePlan({
                        variables: {
                          id: data?.healthCoachGetPatientWellnessPlan.id
                        }
                      })}>Delete</Button>
                    )}
                    <Flex flex={1} />
                    <Flex>

                      <Button type='button' variant={'outline'} style={{ width: 'fit-content', padding: '4px 16px' }} mr={3} disabled={!!loading || !!loadingSave || !!loadingDelete} onClick={onClose}>Cancel</Button>
                      <Button type='button' variant={'primary'} style={{ width: 'fit-content', padding: '4px 16px' }} disabled={!!loading || !!loadingSave || !!loadingDelete} onClick={submitForm}>Save</Button>
                    </Flex>
                  </Flex>
                </Form>
                )
              }}</Formik>
          </EditorWrapper>
        )}
      </Flex>

    </Flex>
  )
}